<template>
<van-overlay :show="showMini" :z-index="3000">
    <div class="wrapper">
        <div class="content">
            <div class="title">温馨提示</div>
            <div class="message">{{message}}</div>
            <div class="qr-code-box" >
                <div class="qr-code-content">
                    <img class="qr-code" :src="minImg" />
                </div>
                
            </div>
        </div>
        <img src="@/assets/icon/close_img.png" class="close-img" @click="cancel">
    </div>
</van-overlay>
</template>
<script>
import http from "@/utils/http";
import api from "@/utils/api";
import { getQueryString } from '@/utils/common.js'
export default {
   name: 'MiniDialog',
   props:{
       showMini:{
           type: Boolean,
           default: false
       },
       message:{
           type: String,
           default:''
       },
       cid:{
           type: String,
           default:''
       },
       qrCodeUrl: {
           type: String,
           default: ''
       }
   },
   data:()=>{
       return {
           minImg:'',
           loadingMinImg: false,
       }
   },
   watch: {
       showMini(val) {
           if (val) {
               this.initMinImg()
           }
       },
       qrCodeUrl() {
           if (this.showMini) {
               this.initMinImg()
           }
       },
       cid() {
           if (this.showMini) {
               this.initMinImg()
           }
       },
   },
   methods: {
       cancel() {
           this.$emit('close')
       },
       initMinImg() {   
            if (this.loadingMinImg) return
            if (this.qrCodeUrl) {
                this.minImg = this.qrCodeUrl
                return
            }
            let cid = this.cid || getQueryString('cid');
            if(!cid) return;
            let param = {
                cid,
                source: "h5",
            }; 
            this.loadingMinImg = true
            http.get(api.checkin.getQrocde, param).then((res) => {
                this.minImg = (res && res.data && res.data.url) ? res.data.url : ''
            }).catch(() => {
                this.minImg = ''
            }).finally(() => {
                this.loadingMinImg = false
            })
        },
   }
}
</script>
<style lang="scss" scoped>
@function rem($px) {
   @return $px / 75 + rem;
}
.wrapper {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.content {
    width: rem(640);
    background-color: #fff;
    border-radius: rem(8);
}
.title {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: rem(80);
    font-size: rem(30);
    color: #333;
}
.message {
    text-align: center;
    font-size: rem(28);
    color: #666;
    padding: rem(10);
}

.qr-code-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: rem(40) rem(30) rem(0);

}
.qr-code-content {
    width: rem(500);
    height: rem(500);
    background-color: #fff;
    border-radius: rem(20);
    padding-bottom: 20px;
}
.qr-code {
    width: 100%;
    height: 100%;
}
.close-img {
    height: rem(48);
    width: rem(48);
    margin-top: rem(30);
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/MiniDialog.vue